import { Outlet } from 'react-router';
import { CFT, PIPE, useSentrySetCft } from '@repo/shared-kit/sentry';

export function KycLayout() {
  useSentrySetCft({ cft: CFT.DUE_DILIGENCE, pipe: PIPE.DUE_DILIGENCE.INITIAL });
  return <Outlet />;
}
